<template>
  <div class="job-share-action-column">
    <WdsMenu
      z-index="50"
      placement="bottom-end"
      manual-trigger
      :global="tableGlobals"
    >
      <template #trigger="{ toggle }">
        <WdsButtonGhost @click="toggle">
          <WdsIcon name="overflow-menu-horizontal" :size="16" />
        </WdsButtonGhost>
      </template>

      <WdsMenuOption :href="jobPath">
        <WdsIcon :size="16" :name="WdsIconNameEnum.VIEW" />
        {{ $t('View job') }}
      </WdsMenuOption>
    </WdsMenu>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import {
  WdsButtonGhost,
  WdsIcon,
  WdsIconNameEnum,
  WdsMenu,
  WdsMenuOption,
} from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { useTableGlobalsSelector } from '@/components/GraphqlDataTable/injection'

const tableGlobals = useTableGlobalsSelector()

const frag = graphql(`
  fragment JobShareActionColumn on JobShare {
    id
    job {
      id
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof frag> }>()
const column = computed(() => useFragment(frag, props.row))

const jobPath = computed(() =>
  laravelNamedRoute('jobs.show', { job: column.value?.job.id }),
)
</script>

<style scoped lang="scss">
.job-share-action-column {
  :deep(.wds-menu) {
    width: max-content;
  }
}
</style>
